var ProductAccordion = /** @class */ (function () {
    function ProductAccordion() {
        this.productPage = document.querySelector('.open-product');
        if (this.productPage.querySelectorAll('.product-accordion-item')) {
            this.accordionItems = Array.from(this.productPage.querySelectorAll('.product-accordion-item'));
            this.addEventListeners();
        }
    }
    ProductAccordion.prototype.addEventListeners = function () {
        var _this = this;
        this.accordionItems.forEach(function (faqItem) {
            var accordionItemHeader = faqItem.querySelector('.product-accordion-item-header');
            accordionItemHeader.addEventListener('click', _this.toggleItem.bind(_this));
        });
    };
    ProductAccordion.prototype.toggleItem = function (event) {
        var itemHeader = event.currentTarget;
        var itemContainer = itemHeader.parentElement;
        var contentIsOpen = itemContainer.classList.contains('active');
        if (contentIsOpen) {
            itemContainer.classList.remove('active');
        }
        else {
            itemContainer.classList.add('active');
        }
    };
    return ProductAccordion;
}());
export default ProductAccordion;
